import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useLanguageContext } from "../../../Context/LanguageContext";
import DatePickerComponent from "../../ReusableComponent/DatePickerComponent/DatePickerComponent";

const FilterConditionRow = ({
  index,
  condition,
  filterList,
  handleConditionChange,
  handleRemoveCondition,
  conditionsLength,
}) => {
  const { localization } = useLanguageContext();
  const selectedFilterDataType =
    filterList.find((filter) => filter.name === condition.Name)?.dataType || "";

  const getOperators = (dataType, name) => {
    if (dataType.toLowerCase() === "string") {
      if (name.toLowerCase() == "anlagestatus") {
        return [{ value: "=", label: "=" }];
      } else {
        return [
          { value: "*", label: localization.startwith },
          { value: "=", label: localization.equal },
          { value: "%", label: localization.contains },
          { value: "$", label: localization.endWith },
          { value: "#", label: localization.empty },
        ];
      }
    } else if (dataType.toLowerCase() === "bool") {
      return [{ value: "=", label: "=" }];
    } else if (
      dataType.toLowerCase() === "int" ||
      dataType.toLowerCase() === "float"
    ) {
      return [
        { value: "=", label: "=" },
        { value: ">", label: ">" },
        { value: "<", label: "<" },
        { value: ">=", label: ">=" },
        { value: "<=", label: "<=" },
        { value: "#", label: "Empty" },
      ];
    } else if (dataType.toLowerCase() === "datetime") {
      return [
        { value: "<", label: "<" },
        { value: ">", label: ">" },
        { value: "=", label: "=" },
        { value: ">=", label: ">=" },
        { value: "<=", label: "<=" },
        { value: "#", label: "Empty" },
      ];
    }
    return [];
  };

  const getInputField = (
    dataType,
    inputValue,
    handleInputChange,
    selectedOperator,
    index,
    name
  ) => {
    if (dataType.toLowerCase() === "string") {
      if (name.toLowerCase() == "anlagestatus") {
        return (
          <FormControl
            fullWidth
            disabled={!selectedOperator || selectedOperator === "#"}
          >
            <Select value={inputValue} onChange={handleInputChange} fullWidth>
              <MenuItem value={"INBE"}>{localization.active}</MenuItem>
              <MenuItem value={"AUSSER BETRIEB"}>
                {localization.inActive}
              </MenuItem>
            </Select>
          </FormControl>
        );
      } else {
        return (
          <TextField
            placeholder={localization.enterValue}
            variant="outlined"
            fullWidth
            value={inputValue}
            onChange={handleInputChange}
            disabled={!selectedOperator || selectedOperator === "#"}
          />
        );
      }
    } else if (dataType.toLowerCase() === "bool") {
      if (name.toLowerCase() == "nio") {
        return (
          <FormControl
            fullWidth
            disabled={!selectedOperator || selectedOperator === "#"}
          >
            <Select value={inputValue} onChange={handleInputChange} fullWidth>
              <MenuItem value={"true"}>{localization.nio}</MenuItem>
              <MenuItem value={"false"}>{localization.io}</MenuItem>
            </Select>
          </FormControl>
        );
      } else {
        return (
          <FormControl
            fullWidth
            disabled={!selectedOperator || selectedOperator === "#"}
          >
            <InputLabel>{localization.value}</InputLabel>
            <Select value={inputValue} onChange={handleInputChange} fullWidth>
              <MenuItem value={"true"}>{localization.trueValue}</MenuItem>
              <MenuItem value={"false"}>{localization.falseValue}</MenuItem>
            </Select>
          </FormControl>
        );
      }
    } else if (dataType.toLowerCase() === "datetime") {
      return (
        <DatePickerComponent
          handleDate={(_value) => {
            handleConditionChange(index, "Value", _value);
          }}
          inputValue={inputValue}
          disabled={!selectedOperator || selectedOperator === "#"}
        />
      );
    } else {
      return (
        <TextField
          placeholder={localization.enterValue}
          variant="outlined"
          fullWidth
          type="number"
          value={inputValue}
          onChange={handleInputChange}
          disabled={!selectedOperator || selectedOperator === "#"}
        />
      );
    }
  };

  return (
    <Grid container spacing={2} marginBottom={2} className="conditionRow">
      <Grid item xs={4}>
        <Typography variant="body1" className="filterlabelStyle">
          {localization.attribute}
        </Typography>
        <FormControl fullWidth variant="outlined">
          <Select
            value={condition.Name}
            onChange={(e) =>
              handleConditionChange(index, "Name", e.target.value)
            }
            sx={{ height: "38px" }}
            fullWidth
            displayEmpty
            className="customSelect"
          >
            <MenuItem value="" disabled>
              {localization.selectAttribute}
            </MenuItem>
            {filterList.map((filter) => (
              <MenuItem key={filter.name} value={filter.name}>
                {filter.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={conditionsLength > 1 ? 3 : 4}>
        <Typography variant="body1" className="filterlabelStyle">
          {localization.operator}
        </Typography>
        <FormControl fullWidth>
          <Select
            sx={{ height: "38px" }}
            value={condition.Operator}
            onChange={(e) =>
              handleConditionChange(index, "Operator", e.target.value)
            }
            fullWidth
            displayEmpty
            disabled={!condition.Name}
          >
            <MenuItem value="" disabled>
              {localization.selectopt}
            </MenuItem>
            {condition.Name &&
              getOperators(selectedFilterDataType, condition.Name).map(
                (operator) => (
                  <MenuItem key={operator.value} value={operator.value}>
                    {operator.label}
                  </MenuItem>
                )
              )}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body1" className="filterlabelStyle">
          {localization.value}
        </Typography>
        <FormControl fullWidth>
          {getInputField(
            selectedFilterDataType,
            condition.Value,
            (e) => handleConditionChange(index, "Value", e.target.value),
            condition.Operator,
            index,
            condition.Name
          )}
        </FormControl>
      </Grid>
      {conditionsLength > 1 && (
        <Grid item xs={1} container justifyContent="flex-end">
          <IconButton onClick={() => handleRemoveCondition(index)}>
            <Delete />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default FilterConditionRow;
